import { render, staticRenderFns } from "./NavSection.vue?vue&type=template&id=3a5ff05f"
import script from "./NavSection.vue?vue&type=script&lang=js"
export * from "./NavSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavItem: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/NavItem.vue').default})
